
import CloseIcon from '@mui/icons-material/Close';
import {AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { DatePickerComponent, TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';
function DialogAccepterIntteruptionOrAnnulerMission({missionId, openDialogAccept, handleCloseAncienDialog, getIntteruption, handleCloseDialogAccept,mode}) {
    DialogAccepterIntteruptionOrAnnulerMission.propTypes = {
        missionId: PropTypes.any,
        openDialogAccept: PropTypes.any,
        mode: PropTypes.any,
        handleCloseDialogAccept: PropTypes.func,
        getIntteruption:PropTypes.func,
        handleCloseAncienDialog:PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const { setBackdropOpen} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const [dateEffective, setDateEffective] = useState(null);
    const [motifInterruption,setMotifInterruption]=useState('');
    const { i18n } = useTranslation();
    const accepterDemande = async (e) => {
        e.preventDefault();
        setBackdropOpen(true);
        try {
            let payload = mode == 'annuler' ?
                {
                    missionId : missionId,
                    statutMission: 'annulee',
                    motifAcceptation:motifInterruption,
                    dateEffective:dateEffective,
                } : {
                    missionId : missionId,
                    wasAccepted:true,
                    motifAcceptation:motifInterruption,
                    dateEffective:dateEffective,
                };
            const response1 = await axiosPrivate.post('mission/traiterInterruptionOrAnnulerMission',payload,);
            // const responseData1 = await response1.data;
            console.log({response1});
            handleCloseDialogAccept();
            handleCloseAncienDialog();
            getIntteruption();
        }catch (error){
            console.log(error.response?.status,error.response?.data.error);
        }
        setBackdropOpen(false);
    };
    return (
        <Dialog
            open={openDialogAccept}
            onClose={handleCloseDialogAccept}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseDialogAccept}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
                <form className='OrdreMissionFileFrame18'>
                    {mode=='annuler' ?
                        <h5 className='OrdreMissionFileFrame19'>
                            {i18n.t('Valider la demande d\'annulation de mission')}
                        </h5>
                        :
                        <h5 className='OrdreMissionFileFrame19'>
                            {i18n.t('Valider la demande d&apos;interruption de mission')}
                        </h5>
                    }
                    <div className='OrdreMissionFileFrame20'>
                        {mode!='annuler' &&
                            <div className='OrdreMissionFileFrame21'>
                                <div className='OrdreMissionFileFrame22'>
                                    <div className='OrdreMissionFileFrame23'>
                                        <p className='OrdreMissionFileFrame24'>{i18n.t('Date effective de l\'interruption')} </p>
                                    </div>
                                    <div className='OrdreMissionFileFrame25'>
                                        <DatePickerComponent
                                            name="dateEffective"
                                            //label="Date effective de l`interruption"
                                            date={dateEffective}
                                            setDate={(newValue) => {
                                                setDateEffective(newValue);
                                                // setDateEffective(newValue);
                                            }}
                                            width={750}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='OrdreMissionFileFrame26'>
                            <div className='OrdreMissionFileFrame23'>
                                {mode=='annuler' ?
                                    <p className='OrdreMissionFileFrame24'>{i18n.t('Motif d\'annulation')} </p>
                                    :
                                    <p className='OrdreMissionFileFrame24'>{i18n.t('Motif à diffuser')} </p>
                                }
                            </div>
                            <div className='OrdreMissionFileFrame27'>
                                <TextFieldComponent
                                    name="motifInterr"
                                    multiline
                                    minRows={4}
                                    value={motifInterruption}
                                    onChange={(e) => setMotifInterruption(e.target.value)}
                                    sx={{
                                        '& > :not(style)': { width: '750px',borderRadius: '8px'},
                                    }}
                                    //defaultValue=""
                                    autoFocus={true}
                                // ref={userRef}
                                //value={email}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='OrdreMissionFileFrame28'>
                        <Button
                            onClick={handleCloseDialogAccept}
                            variant="text"
                            style={{...buttonStyles(),
                            }}
                        >{i18n.t('Annuler')}</Button>

                        <Button
                            variant="contained"
                            type='submit'
                            style={{...buttonStylesGreen(false),
                            }}
                            onClick={accepterDemande}
                        >{i18n.t('Valider')}</Button>
                    </div>
                </form>
            </div>
        </Dialog>
    );
}

export default DialogAccepterIntteruptionOrAnnulerMission;
